import { createElement } from 'react';

import { Controller } from '@hotwired/stimulus';
import { createRoot } from 'react-dom/client';

import { logError } from '../lib/logger';

import ContactsSetupApp from '../components/contacts_setup/ContactsSetupApp';

function parseImport(json) {
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch (error) {
    logError('ContactsSetupController', 'Failed to parse import JSON', { error });
    return null;
  }
}

export default class extends Controller {
  static values = {
    import: String,
    returnUrl: String,
  };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      createElement(ContactsSetupApp, {
        initialImport: parseImport(this.importValue),
        returnUrl: this.returnUrlValue,
      }),
    );
  }

  disconnect() {
    this.root?.unmount();
    this.root = null;
  }
}
